import React from 'react';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { Box } from '@mui/material';
import SubTabs from '../components/common/SubTabs';
import ComingSoon from '../components/common/ComingSoon';
import WeeklyReports from '../components/WeeklyReports';
import ReportBuilder from '../components/ReportBuilder';
import OzonReports from '../components/OzonReports';
import { hasData } from '../utils/marketplaces';

// Section "Отчёты": weekly reports that load by themselves, and the report builder over stored data.
const MarketplaceReportsPage = () => {
  const { marketplace, accounts } = useOutletContext();
  const location = useLocation();
  const navigate = useNavigate();
  const tab = new URLSearchParams(location.search).get('tab') === 'builder' ? 'builder' : 'weekly';

  if (marketplace === 'ozon') return <OzonReports accounts={accounts} />;
  if (!hasData(marketplace)) return <ComingSoon marketplace={marketplace} what="Отчёты" />;
  return (
    <Box>
      <SubTabs items={[{ key: 'weekly', label: 'Еженедельные отчёты WB' }, { key: 'builder', label: 'Конструктор отчётов' }]} value={tab}
        onChange={(v) => navigate({ search: v === 'builder' ? '?tab=builder' : '' }, { replace: true })} sx={{ mb: 3 }} />
      {tab === 'weekly' ? <WeeklyReports accounts={accounts} /> : <ReportBuilder accounts={accounts} />}
    </Box>
  );
};

export default MarketplaceReportsPage;
